export default "__VITE_ASSET__BP7$Oa8y__"